import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconBasketball12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconBasketball12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#Basketball12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M8.922 10.058a5 5 0 0 1-2.422.917V6.5h1.019a6.47 6.47 0 0 0 1.403 3.558m-.4-3.558a5.47 5.47 0 0 0 1.15 2.894A4.98 4.98 0 0 0 10.975 6.5zm2.453-1a4.98 4.98 0 0 0-1.303-2.894A5.47 5.47 0 0 0 8.522 5.5zm-3.456 0a6.47 6.47 0 0 1 1.403-3.558A5 5 0 0 0 6.5 1.025V5.5zM5.5 5.5V1.025a5 5 0 0 0-2.422.917A6.47 6.47 0 0 1 4.481 5.5zm-2.022 0a5.47 5.47 0 0 0-1.15-2.894A4.98 4.98 0 0 0 1.025 5.5zm-2.453 1a4.98 4.98 0 0 0 1.303 2.894A5.47 5.47 0 0 0 3.478 6.5zm3.456 0H5.5v4.475a5 5 0 0 1-2.422-.917A6.47 6.47 0 0 0 4.481 6.5M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="Basketball12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconBasketball12);
